import { render, staticRenderFns } from "./UsersConnectedList.vue?vue&type=template&id=65c95c3d&scoped=true&"
import script from "./UsersConnectedList.vue?vue&type=script&lang=js&"
export * from "./UsersConnectedList.vue?vue&type=script&lang=js&"
import style0 from "./UsersConnectedList.vue?vue&type=style&index=0&id=65c95c3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c95c3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
